import React from 'react';
import PropTypes from 'prop-types';

const InfoChampsObligatoire = ({ className = 'fr-hint-text' }) => {
    return <p className={className}>Les champs marqués d'un astérisque sont obligatoires</p>;
};

InfoChampsObligatoire.propTypes = {
    className: PropTypes.string,
};

export default InfoChampsObligatoire;
